export const USED_AS_SPA = "false" === 'true';
export const SENTRY_DSN = "https://b06ef358f886462f8a6d06f1ec364450@o61655.ingest.sentry.io/5478465" || '';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_STAGING = "n33vr9vfs09671pc90pgi7kvj8q7vvvfvjvd";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SPLIT_IO_API_KEY_PRODUCTION = "9a44abjpf5r66aq6r9o6426v9n2tg9ko9tah";
export default environment => {
  switch (environment) {
    case 'TEST':
    case 'LOCAL':
    case 'DEVELOPMENT':
    case 'STAGING':
      return {
        DATACAMP_DOMAIN: 'datacamp-staging.com',
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_STAGING,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp-staging.com',
          MAIN_APP: 'https://www.datacamp-staging.com',
          TEACH_APP: 'https://teach-api.datacamp-staging.com/teach-app'
        }
      };
    case 'PRODUCTION':
    default:
      return {
        DATACAMP_DOMAIN: 'datacamp.com',
        SPLIT_IO_API_KEY: SPLIT_IO_API_KEY_PRODUCTION,
        urls: {
          CAMPUS_API: 'https://campus-api.datacamp.com',
          MAIN_APP: 'https://www.datacamp.com',
          TEACH_APP: 'https://teach-api.datacamp.com/teach-app'
        }
      };
  }
};